import QueryResults from "./QueryResults";

export default class QueryResults_Archivi extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
  }

  getColumns() {
    let columnDefs = [
      // Filmografia
      this.fr.fieldFilmografia(),
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Media
      this.fr.fieldMedia(),
      // Object ID
      this.fr.fieldPlain("object_id", "ID", 1),
      // Segnatura provvisoria
      this.fr.fieldList("segnatura_provvisoria", "Segnatura provvisoria", 1, null, null, ["numero_provvisorio_sigla_prefisso", "numero_puntamento"], ""),
      // Segnatura definitiva
      this.fr.fieldPlain("segnatura_definitiva", "Segnatura definitiva", 1),
      // Tipo
      this.fr.fieldPlain("type_label", "Tipo", 1),
      // Qual. Tipo
      this.fr.fieldPlain("tipo_ambito", "Qual. Tipo", 1),
      // Titolo
      this.fr.fieldPlain("label", "Titolo", 2),
      // Descrizione
      this.fr.fieldList("descrizione", "Descrizione", 3),
      // Da (crono. specifica)
      this.fr.fieldList(["nuova_cronologia", "data_da"], "Da", 2, null, "data_da"),
      // Note
      this.fr.fieldList("note", "Note", 2),
      // Note di servizio
      this.fr.fieldList("note_di_servizio", "Note di servizio", 3),
      // Nota dell'archivista
      this.fr.fieldList("nota_archivista", "Nota dell'archivista", 2),
      // Entità collegate
      this.fr.fieldList("entities", "Entità collegate", 2, this.dispatch.bind(this), "ARCHIVI_entities", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "entities.rel_entity_id", key: "rel_entity_id" }),
      // Collocazioni collegate
      this.fr.fieldList("unita_di_descrizione_collegate", "Collocazioni collegate", 2, this.dispatch.bind(this), "ARCHIVI_unita_di_descrizione_collegate", "denominazione"),
      // Consistenza fisica
      this.fr.fieldList("consistenza_fisica", "Consistenza fisica", 2),
      // Legatura
      this.fr.fieldList("legatura", "Legatura", 1),
      // Lingua
      this.fr.fieldList("lingua", "Lingua", 1),
      // Tecnica esecutiva
      this.fr.fieldList("tecnica_esecutiva", "Tecnica esecutiva", 1),
      // Tipologia scrittura
      this.fr.fieldList("tipologia_scrittura", "Tipologia scrittura", 1),
      // Dimensioni
      this.fr.fieldList("dimensioni", "Dimensioni", 1, null, null, ["base_s", "altezza"], "<br>"),
      // Danni
      this.fr.fieldList("danni", "Danni", 1, null, null, "danni", "<br>"),
    ];
    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }
}

QueryResults_Archivi.QUERY_entities = {
  id: "QN1731337651748",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731337651749",
      Field: {
        _path: "/entities",
        _label: "/entities",
        Name: "entities",
        Label: "entities",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731337651750",
          Field: {
            _path: "/entities/label",
            _label: "/entities/label",
            Name: "label",
            Label: "label",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "dummy",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "ARCHIVI_coll",
};

QueryResults_Archivi.QUERY_unita_di_descrizione_collegate = {
  id: "QN1731338008855",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731338008864",
      Field: {
        _path: "/unita_di_descrizione_collegate",
        _label: "/unita_di_descrizione_collegate",
        Name: "unita_di_descrizione_collegate",
        Label: "unita_di_descrizione_collegate",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731338008865",
          Field: {
            _path: "/unita_di_descrizione_collegate/denominazione",
            _label: "/unita_di_descrizione_collegate/denominazione",
            Name: "denominazione",
            Label: "denominazione",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "dummy",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "ARCHIVI_coll",
};
